<script>

</script>

<div>
    <a href="https://github.com/bachelor-kreftregisteret" target="_blank">
        Besøk vår GitHub Organization
    </a>
    <a href="https://www.kreftregisteret.no/">Besøk Kreftregisteret</a>
</div>

<style>
    div {
        display: flex;
        flex: 0 0 100%;
        flex-flow: column nowrap;
        min-height: 20em;
        background-color: #000064;
        color: white;
    }

    a {
        color: white;
        margin-top: 2em;
        font-family: 'Arial', sans-serif;
        font-size: 1em;
    }
</style>
